import { render } from "./quotemensaje_ingles.vue?vue&type=template&id=b6b11664&scoped=true"
import script from "./quotemensaje_ingles.vue?vue&type=script&lang=js"
export * from "./quotemensaje_ingles.vue?vue&type=script&lang=js"

import "./quotemensaje_ingles.vue?vue&type=style&index=0&id=b6b11664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b11664"]])

export default __exports__